<template>
  <div>
    <slot v-if="hasUser" />
    <div v-else>
      <loading-indicator v-if="isLoading"/>
      <login-form v-else />
      <b-alert v-if="errorMsg" variant="danger" show>{{ errorMsg }}</b-alert>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LoginForm from '@/components/LoginForm'

/**
* Wrapper component for any content which depends a current user.
* Only shows its content if a user is logged in; else it shows a login form.
* When a session token is passed as query parameter `s`, the component attempts to
* `become` the respecive user.
*/
export default {
  name: 'RequiringUser',
  data () {
    return {
      isLoading: false,
      errorMsg: null
    }
  },
  components: { 'login-form': LoginForm },
  computed: mapGetters(['hasUser']),
  mounted () {
    if (this.hasUser) {
      return
    }
    const sessionToken = this.$route.query.s
    if (sessionToken) {
      this.become(sessionToken)
    }
  },
  methods: {
    async become (sessionToken) {
      this.isLoading = true

      try {
        await this.$store.dispatch('become', { sessionToken })
      } catch (error) {
        this.errorMsg = error.message
      }

      this.isLoading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/RequiringUser.vue